/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import Forgot from './Forgot';

const title = 'Recover Password';

function action(ctx, routeParams) {
  const props = {
    title,
  };

  return {
    chunks: ['loyalty'],
    title,
    component: <Forgot {...props} />,
    routeParams,
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/routes/client/site/auth/password-forgot/index.js